const getAbsoluteOffsetY = ($node: HTMLElement) => {
	let absoluteOffsetY = $node.offsetTop;
	let $offsetParent = $node.offsetParent as HTMLElement|null;

	while ($offsetParent !== null && $offsetParent !== document.body) {
		absoluteOffsetY += $offsetParent.offsetTop;
		$offsetParent = $offsetParent.offsetParent as HTMLElement|null;
	}

	return absoluteOffsetY;
};

const scrollTo = ($targetNode: HTMLElement, scrollOffset: number) => (e: MouseEvent) => {
	window.scrollTo({
		top: getAbsoluteOffsetY($targetNode) - scrollOffset,
		behavior: 'smooth'
	});
};

export default ($node: HTMLElement) => {
	let $target;

	if ($node.dataset.target) {
		$target = document.querySelector($node.dataset.target);
	} else {
		$target = $node.closest('[data-select="contentContainer"]')?.nextElementSibling;
	}

	if ($target) {
		const $scrollLimiter = document.querySelector('[data-select="content-scroll-limiter"]');
		let scrollOffset = $scrollLimiter?.getBoundingClientRect().bottom || 0;

		$node.addEventListener('click', scrollTo($target as HTMLElement, scrollOffset), false);
	}
}
